import { TPayPageFeesDisclaimers } from '../types';

const PARAM_NAMES_BY_FEE_KIND = {
  fixed: { param1: 'CreditAmount', param2: 'DebitAmount' },
  percent: { param1: 'CreditPercent', param2: 'DebitPercent' },
} as const;

type FeeKind = keyof typeof PARAM_NAMES_BY_FEE_KIND;

const getFeeKind = (key: string): FeeKind | null => {
  if (key.includes('fixed')) return 'fixed';
  if (key.includes('percent')) return 'percent';
  return null;
};

export const mapPayPageFeeData = (
  disclaimer: TPayPageFeesDisclaimers,
  numberFormat: Intl.NumberFormat,
): Record<string, string> => {
  const feeKind = getFeeKind(disclaimer.key);
  if (!feeKind) {
    return disclaimer.data;
  }

  const paramNames = PARAM_NAMES_BY_FEE_KIND[feeKind];

  return Object.entries(disclaimer.data).reduce<Record<string, string>>(
    (acc, [paramKey, paramValue]) => {
      const mappedKey = paramNames[paramKey as keyof typeof paramNames] ?? paramKey;
      acc[mappedKey] = numberFormat.format(Number(paramValue));
      return acc;
    },
    {},
  );
};
